import { useNavigate } from "react-router-dom";
import { MdOutlineMap, MdOutlinePublic } from "react-icons/md";
import { FiMapPin } from "react-icons/fi";
import PageHeader from "../../component/pageHeaders";
import "../dashboardScreen/styles.css";
import "./styles.css";

// Setup order: a country needs a region, and a zone needs a country.
const CARDS = [
  {
    head: "Regions",
    description: "Regions (e.g. Gulf, India) and the countries in each",
    navigate: "/Auth/epaper-settings/regions",
    Icon: MdOutlineMap,
  },
  {
    head: "Countries",
    description: "Countries, currency, phone code and default subscription amount",
    navigate: "/Auth/epaper-settings/countries",
    Icon: MdOutlinePublic,
  },
  {
    head: "Zones",
    description: "Zones and the country each belongs to",
    navigate: "/Auth/epaper-settings/zones",
    Icon: FiMapPin,
  },
];

function EpaperSettings() {
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader
        title={"E-Paper Settings"}
        length={"Dashboard / E-Paper Settings"}
        onBack={() => navigate("/Auth")}
      />
      <div className="epaperSettings-cards">
        {CARDS.map(({ head, description, navigate: to, Icon }) => (
          <div key={head} className="dashboard-card" onClick={() => navigate(to)}>
            <div className="card-icon">
              <Icon size={20} color={"#0055a6"} />
            </div>
            <div className="card-content">
              <div className="card-title">{head}</div>
              <div className="card-description">{description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EpaperSettings;
